import { Designer, Profile, Project } from "@brg/api";
import { IDesignerLight } from "shared/common";
import { AppTester } from "supporting";


export const LinkTo = {
    explore: '/',
    studios: '/studios',
    specialProjects: '/special',
    game: '/game',
    exploreData: '/:data',
    exploreHseOnline: '/projects',
    exploreDataHseOnline: '/projects/:data',
    projects: '/projects',
    projectsData: '/projects/:data',
    legals: '/legals',
    legalsAdmin: '/legals/admin',
    license: '/legals/license',
    privacy: '/legals/privacy',
    catalog: '/catalog',
    tag: '/tag/:id',
    tags: '/tags',
    categories: '/categories',
    tagMainModer: '/mainModerTagPage',
    tagCompetencies: '/competencies',
    authors: '/authors',
    tagCategory: '/tag/category/:id',
    tagCategoryChild: '/tag/category/:id/:childId',
    externalTag: 'https://gallllery.com/tc/:id',
    externalTagArtz: 'https://artz.work/tc/:id',
    lab: '/laboratory',
    laboratories: '/laboratories',
    durasov: '/domDurasov',
    samokatMap: '/samokat/map',
    samokat: '/samokat',
    lms: '/lms',
    alumni: '/alumni',
    opa: '/context/hse/opa?DesignerId=:id',
    opa_by_month: '/context/hse/opa?DesignerId=:id',
    opa_search: '/context/hse/opa?DesignerId=:id&search=1',
    map: '/map/',
    mapEducation: '/education_map/',
    mapData: '/map/:data',
    mapIframe: '/map/iframepath',
    createLocation: '/createLocation',
    feed: '/feed',
    partners: '/partners',
    magistracyApply: '/magistracy/apply',

    myCourses: '/courses/profile/my',
    coursePageWithoutId: '/courses/profile',
    coursePage: '/courses/profile/:id',
    myCoursesSchedule: '/courses/profile/schedule',
    myCoursesHomework: '/courses/profile/homework',
    myCoursesGrades: '/courses/profile/grades',
    myCoursesGroups: '/courses/profile/groups',

// lk: '/lk',

    // Тестовые страницы
    moder: '/moder',
    connect: '/connect',
    test: '/project-test',

    // Дизайнер
    designer: '/designer/:id',
    designerEdit: '/designer/edit/:id',


    // Профиль
    profile: '/profile/:id',
    profileEdit: '/profile/edit/:id',

    //Курсы
    courses: "/courses",

    // Проекты
    project: '/project/:id',
    projectEdit: '/edit/:id',
    projectCreate: '/edit',

    // BRND
    startups: '/startups',
    brands: '/brands',
    about: '/about',
    ideas: '/ideas',

    // Организации
    team: '/teams/:id',
    teamEdit: '/team-edit/:id',
    teamCreate: '/team-edit',
    country: '/countries/:id',
    teamFeed: '/team-feed',

    // Превью проекта
    preview: '/preview/:id',

    // рейтинги
    ratings: '/ratings/:id',

    metrics: '/metrics',
    teachersMetrics: '/metrics/teachers',

    // проверка домашки
    checkHomework: '/check-homework/:id',

    // Превью организации
    previewTeam: '/team-preview/:teamName',

    // Превью лонгрида организации
    previewTeamLongread: '/team-longread-preview/:id',

    //Произвольные роуты

    galleries: '/galleries',

    // Конкурсы
    competitions: "/competitions",
    awards: '/awards',
    competition: '/competition/:id',
    competitionEdit: '/competition-edit/:id',
    competitionCreate: '/competition-edit',
    competitionAutomaticCreate: '/competition-automatic-edit',
    competitionBriefCreate: '/competition-brief-edit',
    competitionProjects: '/competition/:id/projects/:data',
    competitionJury: '/competition/:id/jury',
    seasonEdit: '/season-edit/:id',
    seasonCreate: '/season-edit',

    // команды
    Employees: '/team/employees',
    Shop: '/team/shop',
    ShopLocal: '/shop',
    EmployeesModer: '/team/employees/moder',

    // Книги
    book: "/book/:id",
    bookCreateMain: '/books/create',
    bookEdit: "/book-edit/:id",
    bookCreate: "/book-edit",
    bookPreview: "/book-preview/:id",
    bookProjectCreate: "/book-edit-project/:id",
    myBooks: '/mybooks',

    // Контекст
    context: '/context/:id',
    contextwithparam: '/context/hse/:id',
    contextOpa: '/context/hse/opa',
    bilingual: '/bilingual/:id',
    teamBilingual: '/team-bilingual/:id',

    // Девелоп
    develop: '/develop',
    deziiign: '/deziiign',

    // Админка
    admin: '/admin',
    tagAdmin: '/tagAdmin',
    manageTag: '/ManageTag',
    bindingTag: '/tagPlaces',
    roleAdmin: '/roleAdmin',
    seasonsAdmin: '/seasonsAdmin',
    competitionsAdmin: '/competitionsAdmin',
    employeesAdmin: '/employeesAdmin',
    teamAdmin: '/teamAdmin',
    tagExpert: '/tagExpert',
    tagEditor: '/tagEditor',
    eduTagAdmin: '/eduTagAdmin',


    //HSE витрины
    hseLab: '/laboratory',
    hseLabEmployees: '/laboratory/employees',
    hseLabWithParam: '/laboratory/:data',
    hseIll: '/illustration',
    hseIllWithParam: '/illustration/:data',
    hseBooks: '/books',
    hseBooksWithParam: '/books/:data',
    hseColl: '/collaborations',
    hseCollWithParam: '/collaborations/:data',
    hseGal: '/gallery',
    hseGalWithParam: '/gallery/:data',
    hseVS: '/visualResearch',
    hseLocalBooks: '/hseBooks',
    hseVSWithParam: '/visualResearch/:data',
    hseManagement: '/management',
    hseManagementWithParam: '/management/:data',
    hseStartup: '/startup',
    hseStartupWithParam: '/startup/:data',
    hseCGLAB: '/CGLAB',
    hseCGLABWithParam: '/CGLAB/:data',
    hseSound: '/sound',
    hseSoundWithParam: '/sound/:data',
    hsePro: '/pro',

    externalCreativeLink: 'https://creative.hse.ru/creativecity/',
    externalCreativeLinkData: 'https://creative.hse.ru/creativecity/:data',

    // Создает ссылку по id
    id: (source: string, id: string): string => source.replace(':id', id),
};

/**
 * Открывает ссылку в новой вкладке
 *
 * Внимание! данная функция направлена только на географию
 *
 * @param path
 */
export function openBlankLink(path: string): void {
    window.open(path, '_blank');
}

/**
 * Создает ссылку до указанного места
 */
export const CreateLinkTo = {
    explore: (uriComponent?: string): string => LinkTo.explore + (uriComponent ?? ''),

    map: (uriComponent?: string): string => LinkTo.map + '?display=map',
    mapEducation: (uriComponent?: string): string => LinkTo.mapEducation + '?display=map',

    bilingual: (id: string): string => LinkTo.id(LinkTo.bilingual, id),
    teamBilingual: (id: string): string => LinkTo.id(LinkTo.teamBilingual, id),

    catalog: (): string => LinkTo.catalog,
    legalDocument: (name: string): string => LinkTo.legals + '/' + name,

    // Мета
    moder: (): string => LinkTo.moder,
    connect: (): string => LinkTo.connect,
    magistracyApply: (): string => LinkTo.magistracyApply,

    // Страница тега
    tag: (id: string): string => LinkTo.id(LinkTo.tag, id),

    // Страница тегов на гэлэри
    externalTag: (id: string): string => LinkTo.externalTag.replace(':id', id),

    externalTagArtz: (id: string): string => LinkTo.externalTagArtz.replace(':id', id),

    // Страница ОПА
    opa: (id: string): string => LinkTo.id(LinkTo.opa, id),
    opaSearch: (id: string): string => LinkTo.id(LinkTo.opa_search, id),

    // Дизайнер
    designer: (id: string): string => LinkTo.id(LinkTo.designer, id),
    designerEdit: (id: string): string => LinkTo.id(LinkTo.designerEdit, id),
    designerNew: (user: Designer | Profile | IDesignerLight): string => CreateLinkTo.designer(!!user?.nickName ? user?.nickName : (!!user.friendlyURLPath ? user.friendlyURLPath : user?.designerId)),

    // Профиль
    profile: (id: string): string => LinkTo.id(LinkTo.profile, id),
    profileEdit: (id: string): string => LinkTo.id(LinkTo.profileEdit, id),

    // Проект
    course: (id: string): string => LinkTo.id(LinkTo.coursePage, id),
    project: (id: string): string => LinkTo.id(LinkTo.project, id),
    projectNew: (project?: Project): string => CreateLinkTo.project(!!project?.friendlyURLPath ? project?.friendlyURLPath : project?.projectId ?? ""),
    projectEdit: (id: string): string => LinkTo.id(LinkTo.projectEdit, id),
    projectCreate: (): string => LinkTo.projectCreate,
    projectCreateByOrganization: (teamId: string): string => `${LinkTo.projectCreate}?teamId=${teamId}`,

    // Превью
    preview: (id: string): string => LinkTo.id(LinkTo.preview, id),
    previewTeam: (id:string): string => LinkTo.id(LinkTo.previewTeam, id),
    previewTeamLongread: (teamName:string): string => LinkTo.id(LinkTo.previewTeamLongread, teamName),

    // Организации
    team: (id: string): string => LinkTo.id(LinkTo.team, id),
    teamEdit: (id: string): string => LinkTo.id(LinkTo.teamEdit, id),
    teamCreate: (): string => LinkTo.teamCreate,
    teamGroup: (teamName: string, groupId: string): string => `/teams/${teamName}/employees/group/${groupId}`,
    country: (country: string): string => `/countries/${country}`,

    // Конкурс 
    competition: (id: string): string => LinkTo.id(LinkTo.competition, id),
    competitionEdit: (id: string): string => LinkTo.id(LinkTo.competitionEdit, id),
    competitionCreate: (): string => LinkTo.competitionCreate,
    competitionAutomaticCreate: (): string => LinkTo.competitionAutomaticCreate,
    competitionBriefCreate: (): string => LinkTo.competitionBriefCreate,
    seasonEdit: (id: string): string => LinkTo.id(LinkTo.seasonEdit, id),
    seasonCreate: (): string => LinkTo.seasonCreate,

    // books explore
    bookExplore: (uriComponent?: string): string => ((!AppTester.isBooksMain() ? "/books" : "") + LinkTo.explore + (uriComponent ?? '')),
    // Глава
    bookProject: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.project, id),
    bookProjectEdit: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.projectEdit, id),
    bookProjectPreview: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.preview, id),
    // Книги
    book: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.book, id),
    bookEdit: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.bookEdit, id),
    bookCreate: (): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.bookCreate,
    bookPreview: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.bookPreview, id),
    bookProjectCreate: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.bookProjectCreate, id),
    bookExternal: (id: string) => process.env.REACT_APP_URL_BOOKS_GALLLLERY + LinkTo.id(LinkTo.book, id),

    // Контекст
    context: (id: string): string => LinkTo.id(LinkTo.context, id),

    // ЛМС
    checkHomework: (studentId: string, projectId: string, themeId: string): string => `${LinkTo.id(LinkTo.checkHomework, projectId)}?themeId=${themeId}&studentId=${studentId}`,

    // Переход на страницу дизайнера с открытием вкладки
    designerTab: (id: string, tab: string): string => LinkTo.id(LinkTo.designer, id) + decodeQ({ tab }),

    tagAdmin: (): string => LinkTo.tagAdmin,
    tagMainModerPage: (): string => LinkTo.tagMainModer,
    manageTag: (): string => LinkTo.manageTag,
    bindingTag: (): string => LinkTo.bindingTag,
    roleAdmin: (): string => LinkTo.roleAdmin,
    seasonsAdmin: (): string => LinkTo.seasonsAdmin,
    competitionsAdmin: (): string => LinkTo.competitionsAdmin,
    employeesAdmin: (): string => LinkTo.employeesAdmin,
    teamAdmin: (): string => LinkTo.teamAdmin,
    tagExpert: (): string => LinkTo.tagExpert,
    tagEditor: (): string => LinkTo.tagEditor,
    eduTagAdmin: (): string => LinkTo.eduTagAdmin,
};

export const CreateExternalLinkTo = {
    gallllery: (path = ''): string => process.env.REACT_APP_GALLERY_LINK + path,
    hseSpace: (path = ''): string => process.env.REACT_APP_URL_HSE_SPACE + path,
    mediiia: (path = ''): string => process.env.REACT_APP_URL_MEDIIIA_COM + path,
    deziiign: (path = ''): string => process.env.REACT_APP_URL_DEZIIIGN + path,
    shopBrands: (path = ''): string => process.env.REACT_APP_URL_SHOP_BRANDS + path,
    shopGalllery: (path = ''): string => process.env.REACT_APP_URL_SHOP_GALLLLERY + path,
    portfolio365: (path = ''): string => process.env.REACT_APP_URL_PORTFOLIO_365 + path,
    kiiidsArt: (path = ''): string => process.env.REACT_APP_URL_KIIIDS_ART + path,
};

/**
 * Расшифровывает запрос
 * @param q
 */
export const decodeQ = (q: Record<string, string>): string => {
    return '?' + new URLSearchParams(q).toString();
};
import { Designer, Profile, Project } from "@brg/api";
import { IDesignerLight } from "shared/common";
import { AppTester } from "supporting";


export const LinkTo = {
    explore: '/',
    studios: '/studios',
    specialProjects: '/special',
    game: '/game',
    exploreData: '/:data',
    exploreHseOnline: '/projects',
    exploreDataHseOnline: '/projects/:data',
    projects: '/projects',
    projectsData: '/projects/:data',
    legals: '/legals',
    legalsAdmin: '/legals/admin',
    license: '/legals/license',
    privacy: '/legals/privacy',
    catalog: '/catalog',
    tag: '/tag/:id',
    tags: '/tags',
    categories: '/categories',
    tagMainModer: '/mainModerTagPage',
    tagCompetencies: '/competencies',
    authors: '/authors',
    tagCategory: '/tag/category/:id',
    tagCategoryChild: '/tag/category/:id/:childId',
    externalTag: 'https://gallllery.com/tc/:id',
    externalTagArtz: 'https://artz.work/tc/:id',
    lab: '/laboratory',
    laboratories: '/laboratories',
    durasov: '/domDurasov',
    samokatMap: '/samokat/map',
    samokat: '/samokat',
    lms: '/lms',
    alumni: '/alumni',
    opa: '/context/hse/opa?DesignerId=:id',
    opa_by_month: '/context/hse/opa?DesignerId=:id',
    opa_search: '/context/hse/opa?DesignerId=:id&search=1',
    map: '/map/',
    mapEducation: '/education_map/',
    mapData: '/map/:data',
    mapIframe: '/map/iframepath',
    createLocation: '/createLocation',
    feed: '/feed',
    partners: '/partners',
    magistracyApply: '/magistracy/apply',

    myCourses: '/courses/profile/my',
    coursePageWithoutId: '/courses/profile',
    coursePage: '/courses/profile/:id',
    myCoursesSchedule: '/courses/profile/schedule',
    myCoursesHomework: '/courses/profile/homework',
    myCoursesGrades: '/courses/profile/grades',
    myCoursesGroups: '/courses/profile/groups',

// lk: '/lk',

    // Тестовые страницы
    moder: '/moder',
    connect: '/connect',
    test: '/project-test',

    // Дизайнер
    designer: '/designer/:id',
    designerEdit: '/designer/edit/:id',


    // Профиль
    profile: '/profile/:id',
    profileEdit: '/profile/edit/:id',

    //Курсы
    courses: "/courses",

    // Проекты
    project: '/project/:id',
    projectEdit: '/edit/:id',
    projectCreate: '/edit',

    // BRND
    startups: '/startups',
    brands: '/brands',
    about: '/about',
    ideas: '/ideas',

    // Организации
    team: '/teams/:id',
    teamEdit: '/team-edit/:id',
    teamCreate: '/team-edit',
    country: '/countries/:id',
    teamFeed: '/team-feed',

    // Превью проекта
    preview: '/preview/:id',

    // рейтинги
    ratings: '/ratings/:id',

    metrics: '/metrics',
    teachersMetrics: '/metrics/teachers',

    // проверка домашки
    checkHomework: '/check-homework/:id',

    // Превью организации
    previewTeam: '/team-preview/:teamName',

    // Превью лонгрида организации
    previewTeamLongread: '/team-longread-preview/:id',

    //Произвольные роуты

    galleries: '/galleries',

    // Конкурсы
    competitions: "/competitions",
    awards: '/awards',
    competition: '/competition/:id',
    competitionEdit: '/competition-edit/:id',
    competitionCreate: '/competition-edit',
    competitionAutomaticCreate: '/competition-automatic-edit',
    competitionBriefCreate: '/competition-brief-edit',
    competitionProjects: '/competition/:id/projects/:data',
    competitionJury: '/competition/:id/jury',
    seasonEdit: '/season-edit/:id',
    seasonCreate: '/season-edit',

    // команды
    Employees: '/team/employees',
    Shop: '/team/shop',
    ShopLocal: '/shop',
    EmployeesModer: '/team/employees/moder',

    // Книги
    book: "/book/:id",
    bookCreateMain: '/books/create',
    bookEdit: "/book-edit/:id",
    bookCreate: "/book-edit",
    bookPreview: "/book-preview/:id",
    bookProjectCreate: "/book-edit-project/:id",
    myBooks: '/mybooks',

    // Контекст
    context: '/context/:id',
    contextwithparam: '/context/hse/:id',
    contextOpa: '/context/hse/opa',
    bilingual: '/bilingual/:id',
    teamBilingual: '/team-bilingual/:id',

    // Девелоп
    develop: '/develop',
    deziiign: '/deziiign',

    // Админка
    admin: '/admin',
    tagAdmin: '/tagAdmin',
    manageTag: '/ManageTag',
    bindingTag: '/tagPlaces',
    roleAdmin: '/roleAdmin',
    seasonsAdmin: '/seasonsAdmin',
    competitionsAdmin: '/competitionsAdmin',
    employeesAdmin: '/employeesAdmin',
    teamAdmin: '/teamAdmin',
    tagExpert: '/tagExpert',
    tagEditor: '/tagEditor',
    eduTagAdmin: '/eduTagAdmin',


    //HSE витрины
    hseLab: '/laboratory',
    hseLabEmployees: '/laboratory/employees',
    hseLabWithParam: '/laboratory/:data',
    hseIll: '/illustration',
    hseIllWithParam: '/illustration/:data',
    hseBooks: '/books',
    hseBooksWithParam: '/books/:data',
    hseColl: '/collaborations',
    hseCollWithParam: '/collaborations/:data',
    hseGal: '/gallery',
    hseGalWithParam: '/gallery/:data',
    hseVS: '/visualResearch',
    hseLocalBooks: '/hseBooks',
    hseVSWithParam: '/visualResearch/:data',
    hseManagement: '/management',
    hseManagementWithParam: '/management/:data',
    hseStartup: '/startup',
    hseStartupWithParam: '/startup/:data',
    hseCGLAB: '/CGLAB',
    hseCGLABWithParam: '/CGLAB/:data',
    hseSound: '/sound',
    hseSoundWithParam: '/sound/:data',
    hsePro: '/pro',

    externalCreativeLink: 'https://creative.hse.ru/creativecity/',
    externalCreativeLinkData: 'https://creative.hse.ru/creativecity/:data',

    // Создает ссылку по id
    id: (source: string, id: string): string => source.replace(':id', id),
};

/**
 * Открывает ссылку в новой вкладке
 *
 * Внимание! данная функция направлена только на географию
 *
 * @param path
 */
export function openBlankLink(path: string): void {
    window.open(path, '_blank');
}

/**
 * Создает ссылку до указанного места
 */
export const CreateLinkTo = {
    explore: (uriComponent?: string): string => LinkTo.explore + (uriComponent ?? ''),

    map: (uriComponent?: string): string => LinkTo.map + '?display=map',
    mapEducation: (uriComponent?: string): string => LinkTo.mapEducation + '?display=map',

    bilingual: (id: string): string => LinkTo.id(LinkTo.bilingual, id),
    teamBilingual: (id: string): string => LinkTo.id(LinkTo.teamBilingual, id),

    catalog: (): string => LinkTo.catalog,
    legalDocument: (name: string): string => LinkTo.legals + '/' + name,

    // Мета
    moder: (): string => LinkTo.moder,
    connect: (): string => LinkTo.connect,
    magistracyApply: (): string => LinkTo.magistracyApply,

    // Страница тега
    tag: (id: string): string => LinkTo.id(LinkTo.tag, id),

    // Страница тегов на гэлэри
    externalTag: (id: string): string => LinkTo.externalTag.replace(':id', id),

    externalTagArtz: (id: string): string => LinkTo.externalTagArtz.replace(':id', id),

    // Страница ОПА
    opa: (id: string): string => LinkTo.id(LinkTo.opa, id),
    opaSearch: (id: string): string => LinkTo.id(LinkTo.opa_search, id),

    // Дизайнер
    designer: (id: string): string => LinkTo.id(LinkTo.designer, id),
    designerEdit: (id: string): string => LinkTo.id(LinkTo.designerEdit, id),
    designerNew: (user: Designer | Profile | IDesignerLight): string => CreateLinkTo.designer(!!user?.nickName ? user?.nickName : (!!user.friendlyURLPath ? user.friendlyURLPath : user?.designerId)),

    // Профиль
    profile: (id: string): string => LinkTo.id(LinkTo.profile, id),
    profileEdit: (id: string): string => LinkTo.id(LinkTo.profileEdit, id),

    // Проект
    course: (id: string): string => LinkTo.id(LinkTo.coursePage, id),
    project: (id: string): string => LinkTo.id(LinkTo.project, id),
    projectNew: (project?: Project): string => CreateLinkTo.project(!!project?.friendlyURLPath ? project?.friendlyURLPath : project?.projectId ?? ""),
    projectEdit: (id: string): string => LinkTo.id(LinkTo.projectEdit, id),
    projectCreate: (): string => LinkTo.projectCreate,
    projectCreateByOrganization: (teamId: string): string => `${LinkTo.projectCreate}?teamId=${teamId}`,

    // Превью
    preview: (id: string): string => LinkTo.id(LinkTo.preview, id),
    previewTeam: (id:string): string => LinkTo.id(LinkTo.previewTeam, id),
    previewTeamLongread: (teamName:string): string => LinkTo.id(LinkTo.previewTeamLongread, teamName),

    // Организации
    team: (id: string): string => LinkTo.id(LinkTo.team, id),
    teamEdit: (id: string): string => LinkTo.id(LinkTo.teamEdit, id),
    teamCreate: (): string => LinkTo.teamCreate,
    teamGroup: (teamName: string, groupId: string): string => `/teams/${teamName}/employees/group/${groupId}`,
    country: (country: string): string => `/countries/${country}`,

    // Конкурс 
    competition: (id: string): string => LinkTo.id(LinkTo.competition, id),
    competitionEdit: (id: string): string => LinkTo.id(LinkTo.competitionEdit, id),
    competitionCreate: (): string => LinkTo.competitionCreate,
    competitionAutomaticCreate: (): string => LinkTo.competitionAutomaticCreate,
    competitionBriefCreate: (): string => LinkTo.competitionBriefCreate,
    seasonEdit: (id: string): string => LinkTo.id(LinkTo.seasonEdit, id),
    seasonCreate: (): string => LinkTo.seasonCreate,

    // books explore
    bookExplore: (uriComponent?: string): string => ((!AppTester.isBooksMain() ? "/books" : "") + LinkTo.explore + (uriComponent ?? '')),
    // Глава
    bookProject: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.project, id),
    bookProjectEdit: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.projectEdit, id),
    bookProjectPreview: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.preview, id),
    // Книги
    book: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.book, id),
    bookEdit: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.bookEdit, id),
    bookCreate: (): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.bookCreate,
    bookPreview: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.bookPreview, id),
    bookProjectCreate: (id: string): string => (!AppTester.isBooksMain() ? "/books" : "") + LinkTo.id(LinkTo.bookProjectCreate, id),
    bookExternal: (id: string) => process.env.REACT_APP_URL_BOOKS_GALLLLERY + LinkTo.id(LinkTo.book, id),

    // Контекст
    context: (id: string): string => LinkTo.id(LinkTo.context, id),

    // ЛМС
    checkHomework: (studentId: string, projectId: string, themeId: string): string => `${LinkTo.id(LinkTo.checkHomework, projectId)}?themeId=${themeId}&studentId=${studentId}`,

    // Переход на страницу дизайнера с открытием вкладки
    designerTab: (id: string, tab: string): string => LinkTo.id(LinkTo.designer, id) + decodeQ({ tab }),

    tagAdmin: (): string => LinkTo.tagAdmin,
    tagMainModerPage: (): string => LinkTo.tagMainModer,
    manageTag: (): string => LinkTo.manageTag,
    bindingTag: (): string => LinkTo.bindingTag,
    roleAdmin: (): string => LinkTo.roleAdmin,
    seasonsAdmin: (): string => LinkTo.seasonsAdmin,
    competitionsAdmin: (): string => LinkTo.competitionsAdmin,
    employeesAdmin: (): string => LinkTo.employeesAdmin,
    teamAdmin: (): string => LinkTo.teamAdmin,
    tagExpert: (): string => LinkTo.tagExpert,
    tagEditor: (): string => LinkTo.tagEditor,
    eduTagAdmin: (): string => LinkTo.eduTagAdmin,
};

export const CreateExternalLinkTo = {
    gallllery: (path = ''): string => process.env.REACT_APP_GALLERY_LINK + path,
    hseSpace: (path = ''): string => process.env.REACT_APP_URL_HSE_SPACE + path,
    mediiia: (path = ''): string => process.env.REACT_APP_URL_MEDIIIA_COM + path,
    deziiign: (path = ''): string => process.env.REACT_APP_URL_DEZIIIGN + path,
    shopBrands: (path = ''): string => process.env.REACT_APP_URL_SHOP_BRANDS + path,
    shopGalllery: (path = ''): string => process.env.REACT_APP_URL_SHOP_GALLLLERY + path,
    portfolio365: (path = ''): string => process.env.REACT_APP_URL_PORTFOLIO_365 + path,
    kiiidsArt: (path = ''): string => process.env.REACT_APP_URL_KIIIDS_ART + path,
};

/**
 * Расшифровывает запрос
 * @param q
 */
export const decodeQ = (q: Record<string, string>): string => {
    return '?' + new URLSearchParams(q).toString();
};
